module.exports = __webpack_public_path__ + "static/media/pasaporte.0fee7796.png";